import { createContext, FC, useRef } from 'react';

import { Box } from '@base-app';
import { PageContextProps } from './PageContext.types';

export const PageContext = createContext<any | undefined>(undefined);

const PageContextProvider: FC<PageContextProps> = ({ children, value }) => {
  const ref = useRef(null);

  return (
    <PageContext.Provider value={value}>
      <Box ref={ref}>{children}</Box>
    </PageContext.Provider>
  );
};

export default PageContextProvider;
